import { KeyValue } from '@99designs/graph-utils/types';

type KeyValueWithoutTypename = Pick<KeyValue, 'key' | 'value'>;

export class ServiceProductOptions {
    private productOptions: KeyValue[] = [];
    private productOptionsString = '';

    constructor(options?: KeyValue[] | string) {
        if (!options) {
            return;
        }

        if (Array.isArray(options)) {
            this.productOptions = options;
            this.productOptionsString = this.#toEncodedURIComponent(options);
            return;
        }

        this.productOptions = this.#toKeyValueArray(options);
        this.productOptionsString = options;
    }

    get asArray(): KeyValue[] | undefined {
        return this.productOptions.length ? this.productOptions : undefined;
    }

    get asEncodedURIComponent(): string {
        return this.productOptionsString;
    }

    get(key: string): string | undefined {
        if (!this.productOptions.length) return undefined;

        const option = this.productOptions.find((opt) => opt.key === key);
        return option?.value;
    }

    #toKeyValueArray(uriEncodedOptions: string) {
        const decoded = decodeURIComponent(uriEncodedOptions);
        const options = JSON.parse(decoded) as KeyValueWithoutTypename[];
        const optionsWithTypename = options.map(
            (option): KeyValue => ({
                __typename: 'KeyValue',
                key: option.key,
                value: option.value,
            })
        );
        return optionsWithTypename;
    }

    #toEncodedURIComponent(options: KeyValue[]): string {
        return encodeURIComponent(
            JSON.stringify(
                // strip __typename from KeyValue
                options.map(
                    (option): KeyValueWithoutTypename => ({
                        key: option.key,
                        value: option.value,
                    })
                )
            )
        );
    }
}
